import {Component, OnInit} from '@angular/core';
import {AutorunComponent} from '@myshared/autorun.component';
import {Model} from '../../app.model';
import {ActivatedRoute, Router} from '@angular/router';
import {CountryService} from '../../country/country.service';
import {BankAccount, Company} from "../../company/company.model";
import {CompanyService} from "../../company/company.service";
import {MessageService} from "primeng/api";
import {I18NextService} from "angular-i18next";
import {firstValueFrom} from "rxjs";
import {FormEmitter} from "../../forms/form.component";

@Component({
    selector: 'app-customer-payment-details',
    templateUrl: './customer-payment-details.component.html',
    styleUrls: [],
    standalone: false
})
export class CustomerPaymentDetailsComponent extends AutorunComponent implements OnInit {
  customerId: string;
  customerCompany: Company;
  bankAccount: BankAccount;

  constructor(private m: Model,
              private router: Router,
              private route: ActivatedRoute,
              private countryService: CountryService,
              private companyService: CompanyService,
              private messageService: MessageService,
              private i18next: I18NextService) {
    super();
  }

  async ngOnInit() {
    this.customerId = this.route.snapshot.paramMap.get('customerId');
    this.customerCompany = await firstValueFrom(this.companyService.getCompany(this.customerId));

    this.autorun(() => {
      if (this.customerCompany.bankAccounts.length > 0) {
        this.bankAccount = this.customerCompany.bankAccounts[0];
      } else {
        this.bankAccount = BankAccount.fromJson({});
      }
    });
    this.countryService.refresh();
    this.companyService.refresh();
  }

  onUpdate(form: FormEmitter<BankAccount>) {
    const bankAccount = form.data;
    bankAccount.id = this.bankAccount.id;
    bankAccount.partner_id = +this.customerCompany.id;
    this.companyService.updateBankAccount(bankAccount).subscribe(r => {
      if (r) {
        this.messageService.add({severity: 'success',
          summary: this.i18next.t('company_bankaccount_update_success_summary') as string,
          detail: this.i18next.t('company_bankaccount_update_success_detail') as string});
      } else {
        this.messageService.add({severity: 'error',
          summary: this.i18next.t('company_bankaccount_update_error_summary') as string,
          detail: this.i18next.t('company_bankaccount_update_error_detail') as string});
      }
    });
  }

  public onBack() {
    this.router.navigate(['/customers']);
  }
}
